/**
 * components/landing/company/CompanyPage.jsx — Phase 10 · Company page
 * orchestrator.  Composes the 12 trust-building sections in order.
 */

/**
 * components/landing/company/CompanyPage.jsx — orchestrator.
 *
 * ⚠️ Sections trimmed per the Full Production Stabilization PRD (WORK 4):
 * the following sections have been REMOVED from the Company page because
 * they were either personal-identity content or not aligned with the
 * SaaS-first company positioning:
 *   • Leadership   (CEO / CTO / etc. personal cards)
 *   • Careers      (open roles + culture pillars)
 *   • Press        (media releases + downloadable assets)
 *   • FAQ          (company FAQ)
 *
 * The remaining sections keep the narrative flowing:
 *   1  Hero            — headline + trust chips
 *   2  Story           — how Kalki Ai Cloud came to be
 *   3  MissionVision   — mission + vision statements
 *   4  Values          — the operating values grid
 *   5  Engineering     — the engineering-culture pillars (retained;
 *                        these are product-org attributes, not personal)
 *   6  Milestones      — company milestones + roadmap
 *   7  WhyChoose       — why customers choose Kalki Ai Cloud
 *   8  FinalCTA        — closing invitation
 */

import SiteFrame  from '@/components/landing/SiteFrame'
import Hero           from './sections/Hero'
import Story          from './sections/Story'
import MissionVision  from './sections/MissionVision'
import Values         from './sections/Values'
import Engineering    from './sections/Engineering'
import Milestones     from './sections/Milestones'
import WhyChoose      from './sections/WhyChoose'
import FinalCTA       from './sections/FinalCTA'

const CompanyPage = () => (
  <SiteFrame hideFooterCta={true}>
    <Hero />
    <Story />
    <MissionVision />
    <Values />
    <Engineering />
    <Milestones />
    <WhyChoose />
    <FinalCTA />
  </SiteFrame>
)

export default CompanyPage
